import styled from 'styled-components';

export const Wrapper = styled.header`
  position: fixed;
  z-index: 999;
  padding: 40px 70px;
  background: var(--color-page);
  width: 100%;
  max-width: 1440px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  height: 50px;
  gap: 20px;
  align-items: center;

  @media (max-width: 1460px) {
    padding: 40px 35px;
  }

  @media (max-width: 660px) {
    padding: 40px 16px;
  }

  .primary-button {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-radius: 5px;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;
    background: linear-gradient(90deg, var(--color-gradient-from) 0%, var(--color-gradient-to) 100%);
    border: none;
    color: var(--color-fixed-white);
    white-space: nowrap;
    &:hover {
      background: linear-gradient(90deg, var(--color-banner-gradient-from) 0%, var(--color-banner-gradient-to) 100%);
    }
  }

  .white-button {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-radius: 5px;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;
    color: var(--color-text-muted);
    white-space: nowrap;
    border: 1px solid var(--color-divider);
    background: none;
    &:hover {
      border: 1px solid var(--color-logo);
      color: var(--color-logo);
    }
  }

  .link-button {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-radius: 5px;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;
    white-space: nowrap;
    background: none;
    border: none;
    color: var(--color-title);
    &:hover {
      text-decoration: underline;
    }
  }

  .left-side {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    .logo {
      width: 150px;
      flex: 0 0 auto;
      a {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      svg {
        width: 100%;
        height: auto;
      }
      p {
        font-size: 10px;
      }
    }
  }
  .right-side {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  html[data-theme='dark'] & {
    background: var(--color-page);
    border-bottom: 1px solid var(--color-border);
  }

  html[data-theme='dark'] & .white-button {
    color: var(--color-text-subtle);
    border-color: var(--color-border);
  }

  html[data-theme='dark'] & .white-button:hover {
    color: var(--color-fixed-white);
    border-color: var(--color-link);
  }

  html[data-theme='dark'] & .link-button {
    color: var(--color-link);
  }
`;
